import {
   Component,
   EventEmitter,
   Input,
   OnChanges,
   OnInit,
   Output,
   SimpleChanges,
   TemplateRef,
   ViewChild,
} from '@angular/core';
import { TradeService } from '../../services/trade.service';
import { PortfolioService } from '../../services/portfolio.service';
import { SharedService } from '../../services/shared.service';
import { lastValueFrom, Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Account, TradingAccounts } from 'src/app/models/trading.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Store } from '@ngrx/store';
import { PermissionsState } from 'src/app/stores/access-control/access-control.reducers';
import { AccessControlService } from '../../services/access-control.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'app-buysell',
    templateUrl: './buysell.component.html',
    styleUrls: ['./buysell.component.scss'],
    standalone: false
})
export class BuysellComponent implements OnInit {
   // @Input() country: any;
   // @Input() exchange: any;
   @Input() exchange: any;
   @Input() userRole: any;
   @Input() symbol: any;
   @Input() complianceStatus: any;
   isMobile = false;

   action: string | null = null;

   private subscriptions: Subscription[];

   public isPopupOpen: boolean = false;
   public isTradingEnabled: boolean = false;
   public isTradingAllowed: boolean = false;
   public isUserHoldSymbol: boolean = false;

   public isLoading: boolean = true;

   public accountsHasSymbol: any = [];
   public tradingAccounts: Account[] = [];

   @ViewChild('investPlatformPopup') investPlatformPopup!: TemplateRef<any>;

   constructor(
      private tradeApiService: TradeService,
      private portfolioApiService: PortfolioService,
      private auth: AuthService,
      private sharedService: SharedService,
      private observer: BreakpointObserver,
      private permissionStore: Store<{ permissions: PermissionsState }>,
      private accessControlService: AccessControlService,
      private modalService: NgbModal,
      private router: Router
   ) {
      this.subscriptions = [];
   }

   setPopup() {
      // this.isPopupOpen = !this.isPopupOpen;
      this.tradeApiService.openBuySellPopup(
         this.exchange,
         this.userRole,
         this.symbol,
         this.action,
         this.complianceStatus
      );
   }

   openPremiumPopup() {
      this.sharedService.openUpgradePopup('buySell');
   }

   setAction(action: string) {
      this.action = action;
   }

   async handlePopup(action: string) {
      if (this.auth.getUserId() && this.isTradingAllowed) {
         this.setAction(action);
         
         try {
            const res = await this.tradeApiService.getTradingAccounts<TradingAccounts>(
               this.exchange,
               this.symbol
            );
            
            let hasTradingBrokerage = false;
            if (res.status && res.data) {
               hasTradingBrokerage = res.data.some((account: Account) => account.is_trading_supported);
            }

            if (hasTradingBrokerage) {
               this.openinvestPlatformPopup(hasTradingBrokerage);
            } else {
               this.goToHalalInvesting();
            }
         } catch (err) {
            console.log('Error fetching trading accounts', err);
            this.goToHalalInvesting();
         }
      } else {
         this.goToHalalInvesting();
      }
   }

   continueHere() {
      this.setPopup();
   }

   goToHalalInvesting() {
      this.modalService.dismissAll();
      this.router.navigate(['/halal-investing-platform/']);
   }

   ngOnInit(): void {
      this.observer.observe('(max-width: 1200px)').subscribe((result) => {
         this.isMobile = result.matches;
      });

      this.subscriptions.push(
         this.permissionStore
            .select(
               ({ permissions }) => permissions.permissions.musaffa_trading
            )
            .subscribe((permission) => {
               this.isTradingAllowed = permission;
               // this.isTradingAllowed = true;
            })
      );
   }

   openinvestPlatformPopup(hasBroker: boolean) {
      this.modalService.open(this.investPlatformPopup, {
         centered: true,
         backdrop: 'static',
         windowClass: 'promo-popup-window', 
      });
   }
}
